var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5,4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aad922",
    fillRule: "evenodd",
    d: "M 13.2 21 c -2.7 0 -5 -1.8 -6.3 -4.5 h 4.8 c 0.8 0 1.5 -0.7 1.5 -1.5 s -0.7 -1.5 -1.5 -1.5 H 6 a 11 11 0 0 1 -0.1 -1.5 c 0 -0.5 0.1 -1 0.1 -1.5 h 7.2 c 0.8 0 1.5 -0.7 1.5 -1.5 s -0.7 -1.5 -1.5 -1.5 h -6.3 C 8.1 4.8 10.5 3 13.2 3 c 1.3 0 2.5 0.4 3.6 1.1 a 1.4 1.4 0 0 0 2 -0.4 a 1.5 1.5 0 0 0 -0.4 -2.1 C 16.8 0.6 15 0 13.2 0 c -4.3 0 -7.9 3.1 -9.5 7.5 H 1.5 C 0.7 7.5 0 8.2 0 9 s 0.7 1.5 1.5 1.5 h 1.6 c -0.1 0.5 -0.1 1 -0.1 1.5 s 0.1 1 0.1 1.5 h -1.6 C 0.7 13.5 0 14.2 0 15 s 0.7 1.5 1.5 1.5 h 2.2 c 1.5 4.4 5.2 7.5 9.5 7.5 c 1.8 0 3.6 -0.6 5.2 -1.7 a 1.5 1.5 0 0 0 0.4 -2.1 a 1.4 1.4 0 0 0 -2 -0.4 c -1.1 0.8 -2.3 1.1 -3.6 1.1 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroIcon);
export default __webpack_public_path__ + "static/media/euro-icon.1048a4ea1c2d8aa1dfab17246b28ffa7.svg";
export { ForwardRef as ReactComponent };